import { MyDataGrid, MyTypography } from '../../common/components';
import React from 'react';
import { Stack } from '@mui/material';
import { IconSquareRounded } from '@tabler/icons';
import moment from 'moment';

const getNoteHeader = (group) => {
  if (group === 'internal') return 'Note';
  if (group === 'external') return 'Message';
  return 'Log';
};

export default function ReferralNotesTable({
  onFilterChanged,
  onSelectedRowsChanged,
  loading,
  data,
  onClick,
  isFromNotes = false,
  group = 'internal'
}) {

  const columns = [
    {
      field: 'note',
      headerName: getNoteHeader(group),
      minWidth: 300,
      flex: 1,
      renderCell: (params) => (
        <MyTypography
          component="div"
          variant="subtitle1"
          sx={{
            whiteSpace: 'pre-line',
            wordBreak: 'break-word',
            lineHeight: 1.5,
            py: 1
          }}
        >
          {params.value}
        </MyTypography>
      ),
    },
    {
      field: 'user',
      headerName: 'Created By',
      width: 200,
      valueGetter: params => {
        let user = params.row.user;
        let name = "System Generated";
        if (user) {
          name = user.firstname + ' ' + user.lastname;
          return name;
        }
        if ('clinic' in params.row) {
          name = params.row.clinic;
        }
        return name;
      },
    },
    {
      field: 'created_at',
      headerName: 'Created At',
      width: 250,
      valueGetter: params => {
        const date = moment(params.row.created_at).local().format('DD MMM YYYY - hh:mm:ss A');
        return date;
      },
    },
  ];

  return (
    <>
      {isFromNotes ? (
        <Stack direction="row" spacing={2} sx={{ pb: 1.5 }}>
          <MyTypography variant="h4" sx={{ paddingTop: '3px' }}>Legend:</MyTypography>
          <IconSquareRounded fill="#FF494999" />
          <MyTypography sx={{ paddingTop: '3px' }}>Internal</MyTypography>
          <IconSquareRounded fill="#F5F4F4" />
          <MyTypography sx={{ paddingTop: '3px' }}>External</MyTypography>
        </Stack>) : null}


      <MyDataGrid
        key={'note-data-grid'}
        onFilterChanged={onFilterChanged}
        onSelectedRowsChanged={onSelectedRowsChanged}
        loading={loading}
        data={data}
        columns={columns}
        onClick={onClick}
        showToolbar={false}
        hideFooter={false}
        hideFooterPagination={false}
        sx={{
          '& .MuiDataGrid-cellContent': {
            padding: '16px 8px',
          }
        }}
        getRowId={row => {
          return row.id;
        }}
        getRowClassName={params => `super-app-theme--${params.row.group.name}`}


      />
    </>
  );
}
